import {useAuth0} from "@auth0/auth0-react";
import {useState} from "react";

export const useUserProfile = () => {

    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const API_URL = `${API_BASE_URL}/api/Auth/profile`;

    const {getAccessTokenSilently, isAuthenticated, isLoading} = useAuth0(); // Hook to get Auth0 access token

    const [profile, setProfile] = useState<any | null>(null);
    
    // Function to sync user profile with backend
    const syncUserProfile = async () => {
        if (isLoading || !isAuthenticated) return; // Only sync if user is authenticated
        
        try {
            const token = await getAccessTokenSilently(); // Get the access token silently

            const response = await fetch(API_URL, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok && response.status !== 409) {
                throw new Error(`API call failed: ${response.statusText}`);
            }
            const data = await response.json();
            setProfile(data); // Update profile state with fetched data
        } catch (error) {
        }
    };
    return {profile, isAuthenticated, isLoading, syncUserProfile}; 
}